// import React, { useState, useEffect, useRef } from 'react';
// import { websiteContent } from './data/content';
// import './App.css';
// import logoImg from './assets/clients/scinova_1754034214392-X3h1P0mB.jpg';
// import Scinova_Hero from './assets/clients/Scinova_Hero.png';


// // Animated Counter Component
// const AnimatedCounter = ({ end, duration = 2000, suffix = "" }) => {
//   const [count, setCount] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const counterRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting && !isVisible) {
//           setIsVisible(true);
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (counterRef.current) {
//       observer.observe(counterRef.current);
//     }

//     return () => observer.disconnect();
//   }, [isVisible]);

//   useEffect(() => {
//     if (!isVisible) return;

//     let startTime;
//     let animationFrame;

//     const animate = (currentTime) => {
//       if (!startTime) startTime = currentTime;
//       const progress = (currentTime - startTime) / duration;

//       if (progress < 1) {
//         setCount(Math.floor(end * progress));
//         animationFrame = requestAnimationFrame(animate);
//       } else {
//         setCount(end);
//       }
//     };

//     animationFrame = requestAnimationFrame(animate);
//     return () => cancelAnimationFrame(animationFrame);
//   }, [isVisible, end, duration]);

//   return <span ref={counterRef}>{count}{suffix}</span>;
// };

// // Particle Component for Background
// const Particle = ({ index }) => {
//   const style = {
//     position: 'absolute',
//     width: `${Math.random() * 4 + 2}px`,
//     height: `${Math.random() * 4 + 2}px`,
//     background: 'rgba(138, 43, 226, 0.3)',
//     borderRadius: '50%',
//     left: `${Math.random() * 100}%`,
//     top: `${Math.random() * 100}%`,
//     animation: `float ${Math.random() * 10 + 10}s ease-in-out infinite`,
//     animationDelay: `${Math.random() * 5}s`,
//   };

//   return <div style={style} />;
// };

// // Scroll Progress Indicator
// const ScrollProgress = () => {
//   const [scrollProgress, setScrollProgress] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
//       const progress = (window.scrollY / totalHeight) * 100;
//       setScrollProgress(progress);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: `${scrollProgress}%`,
//       height: '4px',
//       background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
//       zIndex: 9999,
//       transition: 'width 0.1s ease'
//     }} />
//   );
// };

// // Floating WhatsApp Button
// const WhatsAppButton = () => {
//   const phoneNumber = "919974051262"; // Your phone number

//   return (
//     <a
//       href={`https://wa.me/${phoneNumber}`}
//       target="_blank"
//       rel="noopener noreferrer"
//       style={{
//         position: 'fixed',
//         bottom: '30px',
//         right: '30px',
//         width: '60px',
//         height: '60px',
//         background: '#25D366',
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
//         zIndex: 1000,
//         transition: 'transform 0.3s ease',
//         fontSize: '30px',
//         color: 'white',
//         textDecoration: 'none'
//       }}
//       onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
//       onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//     >
//       💬
//     </a>
//   );
// };

// // Back to Top Button
// const BackToTop = () => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setVisible(window.scrollY > 300);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   if (!visible) return null;

//   return (
//     <button
//       onClick={scrollToTop}
//       style={{
//         position: 'fixed',
//         bottom: '100px',
//         right: '30px',
//         width: '50px',
//         height: '50px',
//         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//         border: 'none',
//         borderRadius: '50%',
//         color: 'white',
//         fontSize: '24px',
//         cursor: 'pointer',
//         boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
//         zIndex: 1000,
//         transition: 'transform 0.3s ease'
//       }}
//       onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
//       onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//     >
//       ↑
//     </button>
//   );
// };

// function App() {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const { company, hero, services, serviceDetails, about, clients, contact, footer } = websiteContent;

//   useEffect(() => {
//     window.scrollTo(0, 0);

//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 50);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToSection = (id) => {
//     const element = document.getElementById(id);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth' });
//       setMobileMenuOpen(false);
//     }
//   };

//   // Statistics data
//   const stats = [
//     { number: 100, suffix: '+', label: 'Projects Delivered' },
//     { number: 20, suffix: '+', label: 'Pharmaceutical Partners' },
//     { number: 15, suffix: '+', label: 'Years Combined Experience' }
//   ];

//   return (
//     <div className="App">
//       <ScrollProgress />
//       <WhatsAppButton />
//       <BackToTop />

//       {/* Navigation */}
//       <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
//         <div className="nav-container">
//           <div className="logo">
//             <img src={logoImg} alt="Company Logo" className="logo-icon" style={{ height: '32px', width: '32px', objectFit: 'contain' }} />
//             <span className="gradient-text">{company.name}</span>
//           </div>
//           <button
//             className="mobile-menu-btn"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? '✕' : '☰'}
//           </button>
//           <div className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
//             <button onClick={() => scrollToSection('home')}>Home</button>
//             <button onClick={() => scrollToSection('services')}>Services</button>
//             <button onClick={() => scrollToSection('about')}>About</button>
//             <button onClick={() => scrollToSection('clients')}>Clients</button>
//             <button onClick={() => scrollToSection('contact')} className="cta-nav-button">Contact Us</button>
//           </div>
//         </div>
//       </nav>

//       {/* Enhanced Hero Section */}
//       <section id="home" className="hero-section">
//         {/* Particle Background */}
//         <div className="particles-container">
//           {[...Array(20)].map((_, i) => <Particle key={i} index={i} />)}
//         </div>

//         <div className="hero-overlay"></div>
//         <div
//           className="hero-background"
//           style={{ backgroundImage: `url(${Scinova_Hero})` }}
//         ></div>

//         <div className="container hero-content">
//           <div className="hero-logo-wrapper">
//             <img src={logoImg} alt="Scinova Logo" className="hero-logo" />
//           </div>
//           <h1 className="fade-in-up gradient-text-hero">{company.name}</h1>
//           <h2 className="tagline fade-in-up">Transforming Healthcare Through Science</h2>
//           <p className="description fade-in-up">{company.description}</p>

//           {/* Animated Statistics */}
//           <div className="hero-stats">
//             {stats.map((stat, index) => (
//               <div key={index} className="stat-card glass-effect" style={{ animationDelay: `${index * 0.2}s` }}>
//                 <div className="stat-number">
//                   <AnimatedCounter end={stat.number} suffix={stat.suffix} />
//                 </div>
//                 <div className="stat-label">{stat.label}</div>
//               </div>
//             ))}
//           </div>

//           <div className="cta-buttons">
//             <button
//               className="cta-button primary-cta"
//               onClick={() => scrollToSection('contact')}
//             >
//               Get in Touch
//             </button>
//             <button
//               className="cta-button secondary-cta"
//               onClick={() => scrollToSection('services')}
//             >
//               Explore Services
//             </button>
//           </div>
//         </div>

//         <div className="scroll-indicator">
//           {/* <div className="scroll-arrow">↓</div> */}
//           {/* <span>Scroll to explore</span> */}
//         </div>
//       </section>

//       {/* Services Overview */}
//       <section id="services" className="services-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title gradient-text">{services.title}</h2>
//             <div className="title-underline"></div>
//           </div>
//           <div className="services-grid">
//             {services.categories.map((category, index) => (
//               <div
//                 key={category.id}
//                 className="service-card glass-card"
//                 style={{ animationDelay: `${index * 0.1}s` }}
//               >
//                 <div className="card-number">{String(category.id).padStart(2, '0')}</div>
//                 <h3>{category.title}</h3>
//                 <ul>
//                   {category.items.map((item, idx) => (
//                     <li key={idx}>
//                       <span className="check-icon">✓</span>
//                       {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Service Details */}
//       <section className="service-details-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title gradient-text">Our Expertise in Detail</h2>
//             <div className="title-underline"></div>
//           </div>
//           <div className="details-grid">
//             {serviceDetails.map((service) => (
//               <div key={service.id} className="detail-card">
//                 <div className="detail-image-wrapper">
//                   <img src={service.image} alt={service.title} className="detail-image" loading="lazy" />
//                   <div className="image-overlay">
//                     <div className="icon">{service.icon}</div>
//                   </div>
//                 </div>
//                 <div className="detail-content">
//                   {service.link ? (
//                     <h3>
//                       <a href={service.link} target="_blank" rel="noopener noreferrer">
//                         {service.title} <span className="external-link">↗</span>
//                       </a>
//                     </h3>
//                   ) : (
//                     <h3>{service.title}</h3>
//                   )}
//                   <p className="detail-description">{service.description}</p>
//                   {service.features && (
//                     <div className="features-list">
//                       <h4>Key Features:</h4>
//                       <ul>
//                         {service.features.map((feature, idx) => (
//                           <li key={idx}>
//                             <span className="feature-dot"></span>
//                             {feature}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}
//                   {service.detailedInfo && (
//                     <p className="detailed-info">{service.detailedInfo}</p>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Section */}
//       <section id="about" className="about-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">{about.title}</h2>
//             <div className="title-underline light"></div>
//           </div>
//           <p className="about-description">{about.description}</p>
//           <div className="values-grid">
//             {about.values.map((value, index) => (
//               <div key={index} className="value-card glass-effect">
//                 <div className="value-icon">{value.icon}</div>
//                 <h3>{value.title}</h3>
//                 <p>{value.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Clients Section */}
//       <section id="clients" className="clients-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title gradient-text">{clients.title}</h2>
//             <div className="title-underline"></div>
//           </div>
//           <p className="subtitle">{clients.subtitle}</p>

//           <div className="clients-wrapper" style={{ margin: '60px 0' }}>
//             <div className="clients-grid">
//               {clients.companies.map((client, idx) => (
//                 <div key={`original-${idx}`} className="client-card">
//                   {client.logo ? (
//                     <div className="client-logo-image">
//                       <img src={client.logo} alt={client.name} loading="lazy" />
//                     </div>
//                   ) : (
//                     <div className="client-logo">
//                       {client.name.substring(0, 2).toUpperCase()}
//                     </div>
//                   )}
//                   <div className="client-name">{client.name}</div>
//                 </div>
//               ))}
//               {clients.companies.map((client, idx) => (
//                 <div key={`duplicate-${idx}`} className="client-card">
//                   {client.logo ? (
//                     <div className="client-logo-image">
//                       <img src={client.logo} alt={client.name} loading="lazy" />
//                     </div>
//                   ) : (
//                     <div className="client-logo">
//                       {client.name.substring(0, 2).toUpperCase()}
//                     </div>
//                   )}
//                   <div className="client-name">{client.name}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <p className="note">{clients.note}</p>
//         </div>
//       </section>

//       {/* Contact Section with Google Maps */}
//       <section id="contact" className="contact-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title light">{contact.title}</h2>
//             <div className="title-underline light"></div>
//           </div>
//           <p className="subtitle light">{contact.description}</p>
//           <div className="contact-grid">
//             <div className="contact-card glass-effect">
//               <div className="contact-icon">📍</div>
//               <h3>Our Office</h3>
//               <p className="contact-detail">
//                 <strong>{contact.address.company}</strong><br />
//                 {contact.address.unit}<br />
//                 {contact.address.street}<br />
//                 {contact.address.area}<br />
//                 {contact.address.city}
//               </p>
//             </div>
//             <div className="contact-card glass-effect">
//               <div className="contact-icon">📧</div>
//               <h3>Email Us</h3>
//               {contact.emails.map((email, idx) => (
//                 <p key={idx} className="contact-detail">
//                   <a href={`mailto:${email}`}>{email}</a>
//                 </p>
//               ))}
//             </div>
//             <div className="contact-card glass-effect">
//               <div className="contact-icon">📞</div>
//               <h3>Call Us</h3>
//               {contact.phones.map((phone, idx) => (
//                 <p key={idx} className="contact-detail">
//                   <a href={`tel:${phone.replace(/\s/g, '')}`} className="phone-link">{phone}</a>
//                 </p>
//               ))}
//             </div>
//           </div>

//           {/* Google Maps */}
//           <div className="map-container" style={{ marginTop: '60px' }}>
//             <iframe
//               title="Scinova Scientifics Location"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.6928422396944!2d72.52370331496573!3d23.03534398494234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84f77a0c5555%3A0x0!2zMjPCsDAyJzA3LjIiTiA3MsKwMzEnMzQuOCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
//               width="100%"
//               height="400"
//               style={{ border: 0, borderRadius: '15px' }}
//               allowFullScreen=""
//               loading="lazy"
//             ></iframe>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer">
//         <div className="container">
//           <div className="footer-content">
//             <div className="footer-brand">
//               <h3 className="gradient-text">{company.name}</h3>
//               <p>{footer.tagline}</p>
//             </div>
//             <div className="footer-links">
//               <button onClick={() => scrollToSection('home')}>Home</button>
//               <button onClick={() => scrollToSection('services')}>Services</button>
//               <button onClick={() => scrollToSection('about')}>About</button>
//               <button onClick={() => scrollToSection('contact')}>Contact</button>
//             </div>
//           </div>
//           <div className="footer-bottom">
//             <p>{footer.copyright}</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// }

// export default App;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { websiteContent } from './data/content';
import './App.css';
import logoImg from './assets/clients/scinova_1754034214392-X3h1P0mB.jpg';
import Scinova_Hero from './assets/clients/Scinova_Hero.png';


// Animated Counter Component
const AnimatedCounter = ({ end, duration = 2000, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    let startTime;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = (currentTime - startTime) / duration;

      if (progress < 1) {
        setCount(Math.floor(end * progress));
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isVisible, end, duration]);

  return <span ref={counterRef}>{count}{suffix}</span>;
};

// Particle Component — memoized so positions don't recalculate on every render
const ParticlesBackground = () => {
  const particles = useMemo(() =>
    Array.from({ length: 20 }, (_, i) => ({
      id: i,
      width: Math.random() * 4 + 2,
      height: Math.random() * 4 + 2,
      left: Math.random() * 100,
      top: Math.random() * 100,
      duration: Math.random() * 10 + 10,
      delay: Math.random() * 5,
    })),
    []
  );

  return (
    <div className="particles-container" aria-hidden="true">
      {particles.map((p) => (
        <div
          key={p.id}
          className="particle"
          style={{
            width: `${p.width}px`,
            height: `${p.height}px`,
            left: `${p.left}%`,
            top: `${p.top}%`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

// Scroll Progress Indicator
const ScrollProgress = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      role="progressbar"
      aria-label="Page scroll progress"
      aria-valuenow={Math.round(scrollProgress)}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: `${scrollProgress}%`,
        height: '4px',
        background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
        zIndex: 9999,
        transition: 'width 0.1s ease'
      }}
    />
  );
};

// Floating WhatsApp Button
const WhatsAppButton = () => {
  const phoneNumber = "919974051262";

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      style={{
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        width: '60px',
        height: '60px',
        background: '#25D366',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
        zIndex: 1000,
        transition: 'transform 0.3s ease',
        fontSize: '30px',
        color: 'white',
        textDecoration: 'none'
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
    >
      💬
    </a>
  );
};

// Back to Top Button
const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      style={{
        position: 'fixed',
        bottom: '100px',
        right: '30px',
        width: '50px',
        height: '50px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        border: 'none',
        borderRadius: '50%',
        color: 'white',
        fontSize: '24px',
        cursor: 'pointer',
        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
        zIndex: 1000,
        transition: 'transform 0.3s ease'
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
    >
      ↑
    </button>
  );
};

// ── Contact Form ─────────────────────────────────────────────────────────────
const ContactForm = () => {
  const [form, setForm] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const serviceOptions = [
    'Nutrigenomics Profiling',
    'Anti-counterfeit Technology',
    'Product Development & Sourcing',
    'Medical Writing & Content',
    'Other',
  ];

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = 'Name is required.';
    }

    if (!form.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    if (form.phone && !/^[+\d\s\-()]{7,20}$/.test(form.phone)) {
      newErrors.phone = 'Please enter a valid phone number.';
    }

    if (!form.message.trim()) {
      newErrors.message = 'Message is required.';
    } else if (form.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters.';
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    // Clear error for field on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      // Focus first error field
      const firstErrorField = Object.keys(validationErrors)[0];
      document.getElementById(`cf-${firstErrorField}`)?.focus();
      return;
    }

    setStatus('submitting');

    // ── Replace this block with your actual API / EmailJS / Formspree call ──
    // Example with Formspree:
    // const res = await fetch('https://formspree.io/f/YOUR_FORM_ID', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(form),
    // });
    // if (res.ok) { setStatus('success'); setForm({...}); }
    // else { setStatus('error'); }

    // Simulated delay for demo — remove when you wire up a real endpoint
    await new Promise((res) => setTimeout(res, 1500));
    setStatus('success');
    setForm({ name: '', company: '', email: '', phone: '', service: '', message: '' });
    // ─────────────────────────────────────────────────────────────────────────
  };

  if (status === 'success') {
    return (
      <div className="cf-success" role="alert">
        <div className="cf-success-icon">✓</div>
        <h3>Message received!</h3>
        <p>Thank you for reaching out. We'll get back to you within 1–2 business days.</p>
        <button className="cf-reset-btn" onClick={() => setStatus('idle')}>
          Send another message
        </button>
      </div>
    );
  }

  return (
    <form
      className="contact-form"
      onSubmit={handleSubmit}
      noValidate
      aria-label="Contact inquiry form"
    >
      <div className="cf-row">
        <div className="cf-field">
          <label htmlFor="cf-name" className="cf-label">
            Full name <span className="cf-required" aria-hidden="true">*</span>
          </label>
          <input
            id="cf-name"
            name="name"
            type="text"
            className={`cf-input ${errors.name ? 'cf-input-error' : ''}`}
            value={form.name}
            onChange={handleChange}
            placeholder="Dr. Rajesh Kumar"
            autoComplete="name"
            aria-required="true"
            aria-describedby={errors.name ? 'cf-name-err' : undefined}
          />
          {errors.name && (
            <span id="cf-name-err" className="cf-error" role="alert">{errors.name}</span>
          )}
        </div>

        <div className="cf-field">
          <label htmlFor="cf-company" className="cf-label">Company / Organisation</label>
          <input
            id="cf-company"
            name="company"
            type="text"
            className="cf-input"
            value={form.company}
            onChange={handleChange}
            placeholder="Zydus Pharmaceuticals"
            autoComplete="organization"
          />
        </div>
      </div>

      <div className="cf-row">
        <div className="cf-field">
          <label htmlFor="cf-email" className="cf-label">
            Email <span className="cf-required" aria-hidden="true">*</span>
          </label>
          <input
            id="cf-email"
            name="email"
            type="email"
            className={`cf-input ${errors.email ? 'cf-input-error' : ''}`}
            value={form.email}
            onChange={handleChange}
            placeholder="you@company.com"
            autoComplete="email"
            aria-required="true"
            aria-describedby={errors.email ? 'cf-email-err' : undefined}
          />
          {errors.email && (
            <span id="cf-email-err" className="cf-error" role="alert">{errors.email}</span>
          )}
        </div>

        <div className="cf-field">
          <label htmlFor="cf-phone" className="cf-label">Phone number</label>
          <input
            id="cf-phone"
            name="phone"
            type="tel"
            className={`cf-input ${errors.phone ? 'cf-input-error' : ''}`}
            value={form.phone}
            onChange={handleChange}
            placeholder="+91 99999 00000"
            autoComplete="tel"
            aria-describedby={errors.phone ? 'cf-phone-err' : undefined}
          />
          {errors.phone && (
            <span id="cf-phone-err" className="cf-error" role="alert">{errors.phone}</span>
          )}
        </div>
      </div>

      <div className="cf-field">
        <label htmlFor="cf-service" className="cf-label">Service of interest</label>
        <select
          id="cf-service"
          name="service"
          className="cf-input cf-select"
          value={form.service}
          onChange={handleChange}
        >
          <option value="">Select a service…</option>
          {serviceOptions.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      <div className="cf-field">
        <label htmlFor="cf-message" className="cf-label">
          Message <span className="cf-required" aria-hidden="true">*</span>
        </label>
        <textarea
          id="cf-message"
          name="message"
          className={`cf-input cf-textarea ${errors.message ? 'cf-input-error' : ''}`}
          value={form.message}
          onChange={handleChange}
          placeholder="Tell us about your project, requirements, or any questions you have…"
          rows={5}
          aria-required="true"
          aria-describedby={errors.message ? 'cf-message-err' : undefined}
        />
        {errors.message && (
          <span id="cf-message-err" className="cf-error" role="alert">{errors.message}</span>
        )}
      </div>

      {status === 'error' && (
        <div className="cf-submit-error" role="alert">
          Something went wrong. Please try again or email us directly.
        </div>
      )}

      <button
        type="submit"
        className="cf-submit-btn"
        disabled={status === 'submitting'}
      >
        {status === 'submitting' ? (
          <span className="cf-spinner" aria-label="Sending…" />
        ) : (
          'Send message →'
        )}
      </button>

      <p className="cf-privacy">
        We respect your privacy. Your details are used only to respond to your inquiry.
      </p>
    </form>
  );
};
// ─────────────────────────────────────────────────────────────────────────────

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const { company, hero, services, serviceDetails, about, clients, contact, footer } = websiteContent;

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Track active section for aria-current
      const sections = ['home', 'services', 'about', 'clients', 'contact'];
      for (const id of [...sections].reverse()) {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 120) {
          setActiveSection(id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const stats = [
    { number: 100, suffix: '+', label: 'Projects Delivered' },
    { number: 20, suffix: '+', label: 'Pharmaceutical Partners' },
    { number: 15, suffix: '+', label: 'Years Combined Experience' }
  ];

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'services', label: 'Services' },
    { id: 'about', label: 'About' },
    { id: 'clients', label: 'Clients' },
  ];

  return (
    <div className="App">
      <ScrollProgress />
      <WhatsAppButton />
      <BackToTop />

      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Main navigation">
        <div className="nav-container">
          <div className="logo">
            <img src={logoImg} alt="Scinova Scientifics logo" className="logo-icon" style={{ height: '32px', width: '32px', objectFit: 'contain' }} />
            <span className="gradient-text">{company.name}</span>
          </div>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
            aria-controls="nav-menu"
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
          <div id="nav-menu" className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            {navItems.map(({ id, label }) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                aria-current={activeSection === id ? 'page' : undefined}
              >
                {label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="cta-nav-button"
              aria-current={activeSection === 'contact' ? 'page' : undefined}
            >
              Contact Us
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-section">
        <ParticlesBackground />
        <div className="hero-overlay" aria-hidden="true"></div>
        <div
          className="hero-background"
          style={{ backgroundImage: `url(${Scinova_Hero})` }}
          role="img"
          aria-label="Scinova Scientifics hero background"
        ></div>

        <div className="container hero-content">
          <div className="hero-logo-wrapper">
            <img src={logoImg} alt="Scinova Scientifics" className="hero-logo" />
          </div>
          <h1 className="fade-in-up gradient-text-hero">{company.name}</h1>
          <h2 className="tagline fade-in-up">Transforming Healthcare Through Science</h2>
          <p className="description fade-in-up">{company.description}</p>

          <div className="hero-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card glass-effect" style={{ animationDelay: `${index * 0.2}s` }}>
                <div className="stat-number">
                  <AnimatedCounter end={stat.number} suffix={stat.suffix} />
                </div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="cta-buttons">
            <button className="cta-button primary-cta" onClick={() => scrollToSection('contact')}>
              Get in Touch
            </button>
            <button className="cta-button secondary-cta" onClick={() => scrollToSection('services')}>
              Explore Services
            </button>
          </div>
        </div>

        <div className="scroll-indicator" aria-hidden="true"></div>
      </section>

      {/* Services Overview */}
      <section id="services" className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title gradient-text">{services.title}</h2>
            <div className="title-underline"></div>
          </div>
          <div className="services-grid">
            {services.categories.map((category, index) => (
              <div
                key={category.id}
                className="service-card glass-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="card-number" aria-hidden="true">{String(category.id).padStart(2, '0')}</div>
                <h3>{category.title}</h3>
                <ul>
                  {category.items.map((item, idx) => (
                    <li key={idx}>
                      <span className="check-icon" aria-hidden="true">✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Details */}
      <section className="service-details-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title gradient-text">Our Expertise in Detail</h2>
            <div className="title-underline"></div>
          </div>
          <div className="details-grid">
            {serviceDetails.map((service) => (
              <div key={service.id} className="detail-card">
                <div className="detail-image-wrapper">
                  <img src={service.image} alt={`${service.title} illustration`} className="detail-image" loading="lazy" />
                  <div className="image-overlay" aria-hidden="true">
                    <div className="icon">{service.icon}</div>
                  </div>
                </div>
                <div className="detail-content">
                  {service.link ? (
                    <h3>
                      <a href={service.link} target="_blank" rel="noopener noreferrer">
                        {service.title} <span className="external-link" aria-hidden="true">↗</span>
                      </a>
                    </h3>
                  ) : (
                    <h3>{service.title}</h3>
                  )}
                  <p className="detail-description">{service.description}</p>
                  {service.features && (
                    <div className="features-list">
                      <h4>Key Features:</h4>
                      <ul>
                        {service.features.map((feature, idx) => (
                          <li key={idx}>
                            <span className="feature-dot" aria-hidden="true"></span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {service.detailedInfo && (
                    <p className="detailed-info">{service.detailedInfo}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{about.title}</h2>
            <div className="title-underline light"></div>
          </div>
          <p className="about-description">{about.description}</p>
          <div className="values-grid">
            {about.values.map((value, index) => (
              <div key={index} className="value-card glass-effect">
                <div className="value-icon" aria-hidden="true">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section id="clients" className="clients-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title gradient-text">{clients.title}</h2>
            <div className="title-underline"></div>
          </div>
          <p className="subtitle">{clients.subtitle}</p>

          {/* Smooth infinite scroll carousel — no jump */}
          <div className="clients-wrapper" style={{ margin: '60px 0' }} aria-label="Client logos carousel">
            <div className="clients-grid" aria-hidden="true">
              {/* Three copies so the loop is seamless at any viewport width */}
              {[...clients.companies, ...clients.companies, ...clients.companies].map((client, idx) => (
                <div key={idx} className="client-card">
                  {client.logo ? (
                    <div className="client-logo-image">
                      <img src={client.logo} alt={`${client.name} logo`} loading="lazy" />
                    </div>
                  ) : (
                    <div className="client-logo">{client.name.substring(0, 2).toUpperCase()}</div>
                  )}
                  <div className="client-name">{client.name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Accessible non-animated list for screen readers */}
          <ul className="sr-only">
            {clients.companies.map((client, idx) => (
              <li key={idx}>{client.name}</li>
            ))}
          </ul>

          <p className="note">{clients.note}</p>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title light">{contact.title}</h2>
            <div className="title-underline light"></div>
          </div>
          <p className="subtitle light">{contact.description}</p>

          {/* Two-column layout: info cards + form */}
          <div className="contact-layout">
            <div className="contact-info-col">
              <div className="contact-card glass-effect">
                <div className="contact-icon" aria-hidden="true">📍</div>
                <h3>Our Office</h3>
                <p className="contact-detail">
                  <strong>{contact.address.company}</strong><br />
                  {contact.address.unit}<br />
                  {contact.address.street}<br />
                  {contact.address.area}<br />
                  {contact.address.city}
                </p>
              </div>
              <div className="contact-card glass-effect">
                <div className="contact-icon" aria-hidden="true">📧</div>
                <h3>Email Us</h3>
                {contact.emails.map((email, idx) => (
                  <p key={idx} className="contact-detail">
                    <a href={`mailto:${email}`}>{email}</a>
                  </p>
                ))}
              </div>
              <div className="contact-card glass-effect">
                <div className="contact-icon" aria-hidden="true">📞</div>
                <h3>Call Us</h3>
                {contact.phones.map((phone, idx) => (
                  <p key={idx} className="contact-detail">
                    <a href={`tel:${phone.replace(/\s/g, '')}`} className="phone-link">{phone}</a>
                  </p>
                ))}
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-col">
              <div className="contact-form-wrapper glass-effect">
                <h3 className="cf-heading">Send us a message</h3>
                <p className="cf-subheading">We'll get back to you within 1–2 business days.</p>
                <ContactForm />
              </div>
            </div>
          </div>

          {/* Google Maps */}
          <div className="map-container" style={{ marginTop: '60px' }}>
            <iframe
              title="Scinova Scientifics Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.6928422396944!2d72.52370331496573!3d23.03534398494234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84f77a0c5555%3A0x0!2zMjPCsDAyJzA3LjIiTiA3MsKwMzEnMzQuOCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3 className="gradient-text">{company.name}</h3>
              <p>{footer.tagline}</p>
            </div>
            <nav aria-label="Footer navigation">
              <div className="footer-links">
                <button onClick={() => scrollToSection('home')}>Home</button>
                <button onClick={() => scrollToSection('services')}>Services</button>
                <button onClick={() => scrollToSection('about')}>About</button>
                <button onClick={() => scrollToSection('contact')}>Contact</button>
              </div>
            </nav>
          </div>
          <div className="footer-bottom">
            <p>{footer.copyright}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;